import _ from "underscore";
import $ from "jquery";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements, setUniqNamesAndIds} from "../../utilities/selectorHelpers";
import {createPreventDefault, isPresent, isTruthy, isBlank} from '../../utilities/general';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

const elementsReviewMap = {
  originFacilityName: '.origin-facility-name',
  originFacilityAddress: '.origin-facility-address',
  destFacilityName: '.dest-facility-name',
  destFacilityAddress: '.dest-facility-address',
  targetCompletionDate: '.rev-target-completion-date',
  shippingType: '.rev-shipping-type',
  productsTableBodyReviewTab: ".review-tab-products-table-body"
};

const elementsSourceMap = {
  originFacilityName: ".origin-facility",
  originFacilityAddress: ".origin-fac-address",
  destFacilityName: ".destination-facility",
  destFacilityAddress: ".dest-fac-address",
  shippingType: '.shipping-type',
  targetCompletionDate: '#targetCompletionDate',
  productsTableProductsTab: "#product-tab-transfer-ord-table"
}

const productItemsMap = {
  quantityInput: ".products-tab-quantity-input",
  name: ".products-tab-product-name",
  body: ".products-tab-product-description",
  available: ".products-tab-available-units"
};

export default function ReviewTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const submitOrderURL = wizardElement.data("submit-order-url");
  const viewOrderDetailURL = wizardElement.data("view-order-detail-url");
  const elsReview = {};
  const elsSource = {};

  self.init = function(){
    render();
  };

  self.didNavigateToForm = function() {
    updateSelf();
  }

  function render(){
    setElements();
    bindElements();
  }

  function setElements() {
    setElementsFromScope(elsReview, elementsReviewMap, wizardElement);
    setElementsFromScope(elsSource, elementsSourceMap, wizardElement);
  }

  function bindElements() {

  }

  function updateSelf() {
    elsReview.originFacilityName.text(elsSource.originFacilityName.find(':selected').text());
    elsReview.originFacilityAddress.html(elsSource.originFacilityAddress.html());

    elsReview.destFacilityName.text(elsSource.destFacilityName.find(':selected').text());
    elsReview.destFacilityAddress.html(elsSource.destFacilityAddress.html());

    fillProductsInReviewTab();

    elsReview.targetCompletionDate.text(elsSource.targetCompletionDate.val());
    elsReview.shippingType.text(elsSource.shippingType.find(':selected').text());
  }

  function productsTableRowTemplate({name, body, quantityInput}){
    return (`
      <tr id="0" class="product-item">
        <td>
            ${name}
        </td>
        <td>
            ${body}
        </td>
        <td>
            ${quantityInput}
        </td>
      </tr>
    `);
  }

  function fillProductsInReviewTab(){
    elsReview.productsTableBodyReviewTab.text("");
    const products = elsSource.productsTableProductsTab.find('.product-item');

    products.each(function(){
      const product = $(this);
      const productDetailEls = {};
      const bundleIcon = '<i class="fa fa-cubes q-icon-marg-left" aria-hidden="true"></i>';
      setElementsFromScope(productDetailEls, productItemsMap, product);

      fillProductInReviewTab(productDetailEls);
    });
  }

  function fillProductInReviewTab(pEls){
    const data = {
      name:           pEls.name.text(),
      body:           pEls.body.text(),
      quantityInput:  pEls.quantityInput.val()
    };
    elsReview.productsTableBodyReviewTab.append(productsTableRowTemplate(data));
  }

  const submitModalFlow = new SubmitModalFlow({
    confirmModalTitle: 'Transfer Inventory',
    // confirmModalSubtitle: "Optional Subtitle",
    confirmModalBody: '<div class="q-pad-all-xl">Once you confirm this transfer, the inventory will be allocated and sent to the destination facility.</div>',
    onConfirmClick: function(){
      // Show Loading Modal
        submitModalFlow.showLoadingModal();

      // call ajax funtion here.
      submitOrder({url: submitOrderURL, success: submitOrderSuccess, error: submitOrderError});
      }
  });

  submitModalFlow.init();

  function submitOrder({url, success, error}){
  $.ajax({
      data:  $("#order-transfer-wizard").serialize(),
      url: url,
      type: 'POST',
      success: success,
      error: error
  });
  }

  function submitOrderSuccess(orderId){
   if(orderId){
    EditChecker.setPageClean();
      submitModalFlow.showSuccessModal();
    setTimeout(function() {
     const orderDetailUrlFullURL = `${viewOrderDetailURL}&orderId=${orderId}`;
     window.location.href = orderDetailUrlFullURL;
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
  }
  }


  function submitOrderError(){
    submitModalFlow.showFailureModal();
  }


   $(".create-button").on('click', function() {
    submitModalFlow.showConfirmModal();
   });

}



// WEBPACK FOOTER //
// ./src/pages/transferOrder/ReviewTab.js